import { render, staticRenderFns } from "./SuccessSMS.vue?vue&type=template&id=e55d957e&scoped=true"
var script = {}
import style0 from "./SuccessSMS.vue?vue&type=style&index=0&id=e55d957e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55d957e",
  null
  
)

export default component.exports